import * as React from "react";
import axios from "axios";
import { Button, Paper, Typography, Box } from "@mui/material";
import CropRotateIcon from "@mui/icons-material/CropRotate";
import DriveFolderUploadIcon from "@mui/icons-material/DriveFolderUpload";
import { toast } from "react-toastify";
import { ContextData } from "../../../../../../../context/Context";
import GetPersonData from "../../../../../../../context/GetPersonData";
import PopupDialog from "../../../../../../PopupDialog/PopupDialog";
import Loader from "../../../../../../../routes/Loader";
import baseUrl from "../../../../../../../BaseURL";
import { Postrequest } from "../../../../../../../context/AxiosRequest";
import SoundAlert from "../../../../../../../routes/SoundAlert";

export default function UploadForm(props) {


  const [selectedFile, setSelectedFile] = React.useState(null);
  const { UserTokens, accesstoken } = React.useContext(ContextData);
  const [documentStatus, setDocumentStatus] = React.useState(null);
  const [PersonData, setPersonData] = React.useState(null);
  const [OpenLoader, setOpenLoader] = React.useState(false);
  const [BtnState, setBtnState] = React.useState(true);

  React.useEffect(() => {
    GetPersonData(UserTokens,accesstoken).then((data) => {
      if (data !== null) {
        setPersonData(data);
      }
    });
  }, []);

  React.useEffect(() => {
    if (PersonData) {
      fetchDocumentDetails();
    }
  }, [PersonData]);

  const fetchDocumentDetails = async () => {

    try {
      const response = await axios.get(
        `${baseUrl}/auth/get_upload_document_by_user_token/${UserTokens}/${PersonData.edu_data[0].applying_for_type}/${props.data.doc_token}`,
        {
          headers: { Authorization: `Bearer your_auth_token_here` },
        }  
      );  
      setDocumentStatus(response.data);
        
       if(response){
   
           setBtnState(response.data[0]?.upload_status === "done" || response.data[0]?.verify_status === "accepted");
           console.log(response)
       }


    } catch (error) {
      console.error("Error fetching document details:", error.response?.data || error.message);
    }
  };

  const handleFileChange = (event) => {

    const file = event.target.files[0];

    if (file && file.size > 1048576) {

      toast.error("File size exceeds 1MB. Please select a smaller file.");
      SoundAlert('error')
      return;
      
    }
    setSelectedFile(file);
  };

  const handleUpload = async () => {


    if (!selectedFile) {

      toast.error("Please select a file before uploading.");
         SoundAlert('error')
      return;

      
    }

    const formData = new FormData();
    formData.append("file", selectedFile);
    formData.append("document_type_name", props.data.document_type_name);
    formData.append("residentialType", props.data.resdentialType);
    formData.append("ref_doc_token", props.data.doc_token);
    formData.append("qualification_type", props.data.documentType);
    formData.append("user_token", UserTokens);
    formData.append("file_token", documentStatus && documentStatus[0]?.file_token)
    setOpenLoader(true);

 
      

        axios.post(`${baseUrl}/auth/upload_document_applicant`,formData,{
          withCredentials: true,
          headers: {
            'Accept' : 'application/json',
            ContentType: "multipart/form-data",
          }}).then(res=>{
    
            SoundAlert("success")
            toast.success(res.data.textStatus);
            setDocumentStatus([{ upload_status: "done" }]);
            setOpenLoader(false)
            setBtnState(true)

    
          }).catch(err=> {
              if(err){ 
                toast.error(err.message)
                console.log(err)
                return
    
              }   
          })


  };



  return (
    <Paper
      elevation={2}
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        gap: 1,
        p: 2,
        mb: 2,
        width: "100%",
        maxWidth: "400px", // Adjusted for compact size 
      }}
    >
      <Loader OpenLoader={OpenLoader} />

     <div className="font-mono">

      <Typography variant="subtitle1" sx={{ fontWeight: "bold", fontSize: "14px" }}>
        <span className="font-mono"> Click below to view instructions before uploading </span>
       
      </Typography>

      <PopupDialog type="readinstructUpload" value={props.data.instrct} />

      <Box display="flex" flexDirection="column" alignItems="center" gap={1}>
        {documentStatus && documentStatus[0]?.upload_status === "done" ? (
          <Typography sx={{ color: "green", fontWeight: "bold", fontSize: "12px" }}>
            ✔ Uploaded
          </Typography>
        ) : (
          <>
            <input
              type="file"
              onChange={handleFileChange}
              style={{ display: "none" }}
              id={`file-upload-${props.data.doc_token}`}
              accept=".pdf,.jpg,.jpeg,.png"
            />
            <label htmlFor={`file-upload-${props.data.doc_token}`}>
              <Button
                component="span"
                variant="contained"
                sx={{
                  backgroundColor: "rgb(0, 24, 69)",
                  color: "white",
                  fontSize: "12px",
                  padding: "5px 12px",
                  "&:hover": { backgroundColor: "rgb(0, 18, 55)" },
                }}
                 disabled={BtnState}
                startIcon={<DriveFolderUploadIcon sx={{ fontSize: "1.2em" }} />}
              >
                Choose File
              </Button>
            </label>
          </>
        )}
      </Box>
    {documentStatus && documentStatus[0]?.upload_status === "done"}
      <Button
        variant="contained"
        sx={{
          backgroundColor: "rgb(120, 24, 69)",
          color: "white",
          fontSize: "12px",
          padding: "5px 12px",
          marginTop: "8px",
          "&:hover": { backgroundColor: "rgb(0, 18, 55)" },
        }}
        startIcon={<CropRotateIcon sx={{ fontSize: "1.2em" }} />}
        onClick={handleUpload}
        disabled={BtnState}
      >
         {BtnState ? documentStatus && documentStatus[0]?.upload_status === "done" ?  "Uploaded" : "Loading..." : "Upload"}
      </Button>

                 {
                 documentStatus && documentStatus[0]?.upload_status === "rejected" &&
                     <span className="absolute top-4 bg-red-800 text-white p-1" style={{transform:`translate(-50%,-50%)`, left:`50%`}}>{documentStatus && documentStatus[0]?.upload_status}</span>
                   
                }

                {
                 documentStatus && (documentStatus[0]?.verify_status === "accepted" || documentStatus[0]?.verify_status ===  "Accepted" )&&
                    
                     <span className="absolute top-4 bg-green-800 text-white p-1" style={{transform:`translate(-50%,-50%)`, left:`50%`}}>{documentStatus && documentStatus[0]?.verify_status}</span>
                }

                {
                 documentStatus && (documentStatus[0]?.upload_status === "done" && documentStatus[0]?.verify_status === null) &&

                     <span className="absolute top-4 bg-green-800 text-white p-1" style={{transform:`translate(-50%,-50%)`, left:`50%`}}>Verifying... </span>
                }


     </div>
      

      
    </Paper>
  );
}
